import script from "./MyTransitionSlideX.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyTransitionSlideX.vue?vue&type=script&lang=ts&setup=true"

import "./MyTransitionSlideX.vue?vue&type=style&index=0&id=7508fe56&lang=scss"

const __exports__ = script;

export default __exports__